module.exports = __webpack_public_path__ + "fa8df86b2407d4a02e20814ce8acec97.svg";